// Lightweight UUID v4 generator. Prefers crypto.randomUUID() (Safari 15.4+,
// Chrome 92+, all modern browsers); falls back to a Math.random template-string
// implementation for older iOS Safari. NOT crypto-secure — only used for
// client-side idempotency keys where collision risk is dominated by Omise token
// uniqueness, not the key itself.
export function randomUuid(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof (crypto as unknown as { randomUUID?: () => string }).randomUUID ===
      'function'
  ) {
    return (crypto as unknown as { randomUUID: () => string }).randomUUID()
  }
  // RFC4122 v4-shaped fallback. Bits-pattern preserved (version 4, variant 10xx)
  // so server-side validators that check the format still accept it.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
